import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'

/**
 * Composable for managing user locale preferences
 * - Uses browser locale by default
 * - Overrides with user preference if logged in and has locale set
 */
export function useLocale() {
  const { locale } = useI18n()
  const authStore = useAuthStore()
  const { user } = storeToRefs(authStore)

  // Watch for user changes and update locale accordingly
  watch(
    user,
    newUser => {
      if (newUser && newUser.locale) {
        // User has a locale preference, use it
        locale.value = newUser.locale
      }
      // If user.locale is null, keep using browser locale (already set in i18n.ts)
    },
    { immediate: true }
  )

  return {
    locale,
  }
}
